import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";
const getBrands = async () => {
  const response = await axios.get(`${base_url}class/`);
  return response.data;
};
const getJobtrades = async () => {
  const response = await axios.get(`${base_url}jobtrades`);

  return response.data;
};

const getJobroles = async () => {
  const response = await axios.get(`${base_url}jobtrades`);

  return response.data;
};

const getSectors = async () => {
  const response = await axios.get(`${base_url}sectors`);
  return response.data;
};

const getPrograms = async () => {
  const response = await axios.get(`${base_url}programs`);
  return response.data;
};

const createBrand = async (classes) => {
  try {
    const response = await axios.post(`${base_url}class/`, classes, config);

    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

const updateBrand = async (brand) => {
  const response = await axios.put(
    `${base_url}class/${brand.id}`,
    { title: brand.brandData.title },
    config
  );

  return response.data;
};
const getBrand = async (id) => {
  const response = await axios.get(`${base_url}class/${id}`, config);

  return response.data;
};

const deleteBrand = async (id) => {
  const response = await axios.delete(`${base_url}class/${id}`, config);

  return response.data;
};

const brandService = {
  getBrands,
  getJobtrades,
  getJobroles,
  getSectors,
  getPrograms,
  createBrand,
  getBrand,
  updateBrand,
  deleteBrand,
};

export default brandService;
